/**
 * Checks if a function code matches any allowed code exactly or as a prefix followed by a dash or dot.
 * Examples of valid matches: 4350, 4350-1, 4350-20312, 4350.2, 4350.21, 1050-1, 1050.1, 1050.2, 1050.20312
 */
export const isAllowedFunctionCode = (
  functionCode: string,
  allowedFunctionCodes: string[]
): boolean => {
  return allowedFunctionCodes.some(studentFunctionCode => {
    if (functionCode === studentFunctionCode) {
      return true
    }

    if (functionCode.startsWith(`${studentFunctionCode}-`)) {
      return true
    }

    if (functionCode.startsWith(`${studentFunctionCode}.`)) {
      return true
    }

    return false
  })
}
